import { Model } from '../core/base.model';

export class Country extends Model {
    protected static _resource = 'core/data/countries';

    protected static _version = 'v1';

    get name(): string {
        return this._attributes['name'] || null;
    }

    get frenchName(): string {
        return this._attributes['french_name'] || null;
    }

    get code(): string {
        return this._attributes['code'] || null;
    }
}
